export const fullTimeCourses = [
  {
    id: 1,
    title: "Full-time Front-End Bootcamp",
    img: "https://upload.wikimedia.org/wikiversity/en/8/8a/Javascript.jpg",
    description:
      "Full-time in-person front-end bootcamp focusing on HTML, CSS, JavaScript, and React",
  },
  {
    id: 2,
    title: "Full-time Backend Bootcamp",
    img: "https://www.thoughtco.com/thmb/8J-gnDSb5unt_UP0t05sNJldLJc=/1500x1000/filters:fill(auto,1)/PHP-code-58d2d5803df78c51623a6ce2.jpg",
    description:
      "Full-time in-person back-end bootcamp focusing on developing dynamic web applications in PHP and Ruby.",
  },
  {
    id: 3,
    title: "Full-time UX Bootcamp",
    img: "https://miro.medium.com/max/2000/1*tNg_XU3Fj_sEWowVuedQZA.jpeg",
    description:
      "In-person intensive bootcamp focusing on creating effective user experiences.",
  },
];

export const partTimeCourses = [
  {
    id: 4,
    title: "Part-time front-end course",
    img: "https://www.simplilearn.com/ice9/free_resources_article_thumb/Become_a_Front_End_Developer.jpg",
    description:
      "Part-time in-person front-end development course focusing on React",
  },
  {
    id: 5,
    title: "Part-time Back-End Course",
    img: "https://codecondo.com/wp-content/uploads/2017/09/back-end-developer.jpg",
    description:
      "Part-time in-person back-end development course focusing on Ruby",
  },
];

export const onlineCourses = [
  {
    id: 6,
    title: "Full-Stack Developer Online Bootcamp",
    img: "https://media.geeksforgeeks.org/wp-content/cdn-uploads/20190626123927/untitlsssssed.png",
    description:
      "Self-paced online full-stack development course.",
  },
];
